import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function GA4PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "page_view",
      page_path: location.pathname,
    });
  }, [location]);

  return null;
}

export default GA4PageViewTracker;
